'use strict';

var React = require('react'),
    gradient = require('../utils/gradient'),
    StampImageMixin = require('../mixins/StampImageMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    Img = require('../atoms/Image'),
    Loader = require('../atoms/Loader'),
    FontTest = require('../atoms/FontTest'),
    ZineLink = require('../atoms/ZineLink'),
    SectionTypes = require('../constants/SectionTypes'),
    getScrollY = require('../utils/getScrollY'),
    isBestOf2014Special = require('../utils/isBestOf2014Special'),
    waitForElasticScroll = require('../utils/waitForElasticScroll'),
    { isMobile } = require('../utils/Browser'),
    { PropTypes } = React;

require('./legacy/Stamp.less');
require('./Cover.less');

function stopPropagation(e) {
  e.stopPropagation();
}

var DEFAULT_BACKGROUND = {
  colors: {
    top: 'FFFFFF',
    bottom: 'FFFFFF'
  }
};

var Cover = React.createClass({
  mixins: [PureRenderMixin, StampImageMixin, ClassNameMixin],

  className: 'stamp-Cover',

  propTypes: {
    stamp: PropTypes.object.isRequired,
    isInViewer: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool,
    sectionIndex: PropTypes.number.isRequired,
    isLightboxEnabled: PropTypes.func.isRequired,
    primaryZine: PropTypes.object
  },

  getDefaultProps() {
    return {
      allowEmpty: true
    };
  },

  getImageSizes() {
    return {
      'default': 480,
      'xs': 640,
      'sm': 992,
      'md': 1200,
      'lg': 1440,
      'xl': 1600
    };
  },

  getInitialState() {
    return {
      isAtTop: getScrollY() <= 0,
      imageWrapperStyle: {}
    };
  },

  getCSSModifiers() {
    return {
      clickable: this.shouldOpenLightboxOnClick()
    };
  },

  getImage(props) {
    var { stamp } = props,
        background;

    if (stamp.content) {
      background = stamp.content.sections[0].background;
    }

    return background || stamp.thumbnail || DEFAULT_BACKGROUND;
  },

  shouldOpenLightboxOnClick() {
    var isLightboxEnabled = this.props.isLightboxEnabled(),
        image = this.getImage(this.props),
        { isAtTop } = this.state;

    return isLightboxEnabled && isAtTop && image !== DEFAULT_BACKGROUND;
  },

  preventClicksIfLightboxEnabled() {
    if (!this.shouldOpenLightboxOnClick()) {
      return;
    }

    return {
      onClick: stopPropagation,
      style: {
        cursor: 'default'
      }
    };
  },

  componentDidMount() {
    this.deferUpdateWrapperStyle = window.setTimeout.bind(window, this.updateWrapperStyle, 0);

    window.addEventListener('scroll', this.handleWindowScroll, false);
    window.addEventListener('resize', this.updateWrapperStyle, false);
    window.addEventListener('orientationchange', this.deferUpdateWrapperStyle, false);

    this.updateWrapperStyle();
  },

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleWindowScroll, false);
    window.removeEventListener('resize', this.updateWrapperStyle, false);
    window.removeEventListener('orientationchange', this.deferUpdateWrapperStyle, false);
  },

  updateWrapperStyle() {
    if (!this.isMounted()) {
      return;
    }

    var coverEl = this.getDOMNode(),
        coverWidth = window.innerWidth,
        coverHeight = coverEl.offsetHeight,
        image = this.getImage(this.props),
        originalSize = image.size || {},
        imageHeight = Math.round(coverWidth * (originalSize.height / originalSize.width)) + 1,
        widthScale = Math.max(1, coverHeight / imageHeight);

    this.setState({
      imageWrapperStyle: {
        width: (widthScale * 100) + '%',
        left: (1 - widthScale) / 2 * 100 + '%'
      }
    });
  },

  handleWindowScroll() {
    if (!this.isMounted()) {
      return;
    }

    var scrollY = getScrollY(),
        isAtTop = scrollY <= 0;

    this.setState({
      isAtTop: isAtTop
    });
  },

  render: function () {
    var { stamp, primaryZine, isLoading } = this.props,
        subtitle = stamp.description,
        background = this.getImage(this.props),
        colors = background.colors,
        isDesktop = !isMobile(),
        hasLoadedImage = this.hasLoadedImage(),
        imageStyle = this.props.getLightboxImageStyle(background),
        style;

    if (isDesktop || !hasLoadedImage) {
      style = {
        backgroundImage: gradient('#' + colors.top, '#' + colors.bottom)
      };
    }

    return (
      <div className={this.getClassName()}
           style={style}
           data-lightbox={this.props.lightboxState}
           data-scroll-anchor
           onClick={this.handleClick}>

        <div className='stamp-Cover-imgWrapper'
             style={this.state.imageWrapperStyle}>

          <Img src={this.getImageSrcUrl()}
               ref='image'
               className='stamp-Cover-img'
               style={imageStyle}
               onTransitionEnd={this.handleImageTransitionEnd}
               onLoad={this.handleImageLoad}
               onError={this.handleImageError} />
        </div>

        {isLoading && <Loader />}

        {!isLoading &&
          <div className='stamp-Cover-box'>
            {isBestOf2014Special(primaryZine) &&
              <ZineLink zine={primaryZine}
                className='stamp-Cover-bestOf2014'
                underline='never'
                showTitle>
                Best of 2014
              </ZineLink>
            }

            <h1 className='stamp-Cover-title'
                {...this.preventClicksIfLightboxEnabled()}>
              {stamp.title}
            </h1>

            {subtitle &&
              <FontTest family='minion-pro-condensed'
                        test={subtitle}>
                <h3 className='stamp-Cover-subtitle'
                    dangerouslySetInnerHTML={{ __html: subtitle }}
                    {...this.preventClicksIfLightboxEnabled()} />
              </FontTest>
            }
          </div>
        }

        {this.renderUsageCounter()}
        {this.renderAttributionOnMobile()}
      </div>
    );
  },

  handleClick(e) {
    this.toggleAttributionOnMobile(e);

    if (this.shouldOpenLightboxOnClick()) {
      this.toggleLightbox();
    }
  },

  handleImageTransitionEnd() {
    if (this.props.onImageTransitionEnd) {
      this.props.onImageTransitionEnd();
    }
  },

  toggleLightbox() {
    waitForElasticScroll().then(() => {
      if (!this.isMounted()) {
        return;
      }

      var boundingRect = this.refs.image.getDOMNode().getBoundingClientRect(),
          toHeight = this.getDOMNode().offsetHeight,
          background = this.getImage(this.props);

      this.props.toggleLightbox(
        this.props.sectionIndex,
        SectionTypes.COVER,
        background,
        boundingRect,
        toHeight
      );
    });
  }
});

module.exports = Cover;



/** WEBPACK FOOTER **
 ** ./stamp/Cover.jsx
 **/